import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";
import { Box } from "@mui/material";
import { isDevAuthBypassEnabled } from "../utils/devAuthBypass";
import LoadingState from "./LoadingState";

export default function PrivateRoute({ children, signInUrl = "/login" }) {
  const { isLoaded, isSignedIn } = useAuth();
  if (isDevAuthBypassEnabled()) return children;
  if (!isLoaded) {
    return (
      <Box sx={{ minHeight: "50vh", display: "grid", placeItems: "center", px: 3 }}>
        <LoadingState label="Checking your session" variant="Dots" />
      </Box>
    );
  }
  if (isSignedIn) return children;
  return <Navigate to={signInUrl || "/login"} replace />;
}
